define([], function () {
    'use strict';

    const isVisible = (item, isMobileView) => isMobileView ? item.isVisibleMobile : item.isVisible;

    return {
        isVisible
    };
});
